import * as React from 'react';
import { votestats } from '../../../model/votestats'
import { Doughnut } from 'react-chartjs-2';
import { PALETTE } from '../../../common/styles/palette';

interface IProps {
    dati: votestats
}

export const Grafico = (props: IProps) => {
    return (
        <div>
            <Doughnut

                data={{
                    labels: [
                        'Si',
                        'No',
                        'Non ha votato'],
                    datasets: [{
                        data: [props.dati.sayYes, props.dati.sayNo, props.dati.notRespond],
                        backgroundColor: [PALETTE.PostSent.Chart.YesColor, PALETTE.PostSent.Chart.NoColor, PALETTE.PostSent.Chart.UnansweredColor],
                    }]
                }}
                width={300}
                height={300}
                options={{ maintainAspectRatio: false, responsive: false }}
            />
        </div>
    );
}
